// Información de las fases del ciclo hormonal.
// Lenguaje condicional: "puede influir", "algunas mujeres pueden notar", "podrías intentar".
// NO usar lenguaje absoluto. Las fases son ESTIMADAS, no diagnósticas.

const PHASE_INFO = {
  menstrual: {
    name: 'Menstrual',
    emoji: '🌑',
    color: 'var(--brand-primary)',
    description: 'Es el inicio de tu ciclo. Algunas mujeres pueden notar menos energía, cólicos o necesidad de descansar más.',
    feelings: [
      'Podrías sentir cansancio o menos energía',
      'Algunas mujeres notan cólicos o molestias',
      'Cambios de ánimo o mayor sensibilidad',
      'Posible bajo rendimiento en entrenos intensos'
    ],
    nutrition: [
      'Podrías priorizar alimentos ricos en hierro (carnes magras, lentejas, espinaca)',
      'Hidratación abundante puede ayudar con la retención',
      'Si tienes cravings, podrías intentar opciones con magnesio (chocolate oscuro, almendras)',
      'Evitar excesos de sodio puede reducir la sensación de hinchazón'
    ],
    training: [
      'Si te sientes así, podrías intentar caminatas, yoga o movilidad',
      'Cargas moderadas si te sientes con energía está bien',
      'Escucha tu cuerpo: si necesitas descansar, descansa',
      'Evita exigirte si tienes dolor fuerte'
    ],
    recovery: [
      'Prioriza el sueño (7–9 horas si es posible)',
      'Compresas tibias en abdomen pueden aliviar molestias',
      'Estiramientos suaves o respiración consciente',
      'Date permiso de ir más despacio sin culpa'
    ]
  },
  folicular: {
    name: 'Folicular',
    emoji: '🌱',
    color: '#CCFF00',
    description: 'Tu energía suele ir subiendo. Es una buena fase para retomar intensidad si te sientes con ánimo.',
    feelings: [
      'Energía y motivación tienden a aumentar',
      'Mejor estado de ánimo en muchas mujeres',
      'Mayor claridad mental',
      'Buena disposición para entrenar'
    ],
    nutrition: [
      'Carbohidratos complejos para sostener la energía (avena, quinoa, frutas)',
      'Proteínas magras para apoyar recuperación',
      'Verduras de hoja verde y vegetales variados',
      'Hidratación constante'
    ],
    training: [
      'Buen momento para entrenamientos de fuerza progresiva',
      'Podrías intentar cargas más altas si te sientes lista',
      'HIIT o intervalos pueden rendir mejor',
      'Ideal para aprender nuevos ejercicios o técnica'
    ],
    recovery: [
      'Mantén buen descanso aunque te sientas con energía',
      'Estiramientos post-entreno',
      'Aprovecha para planificar la semana',
      'Sueño consistente sigue siendo clave'
    ]
  },
  ovulatoria: {
    name: 'Ovulatoria',
    emoji: '☀️',
    color: '#00F0FF',
    description: 'Suele ser el pico de energía del ciclo. Muchas mujeres se sienten con mayor fuerza y ánimo.',
    feelings: [
      'Pico de energía y rendimiento posible',
      'Mayor confianza y motivación',
      'Posible aumento de la libido',
      'Buena recuperación post-entreno'
    ],
    nutrition: [
      'Antioxidantes (frutos rojos, vegetales coloridos)',
      'Proteína para sostener entrenos intensos',
      'Grasas saludables (aguacate, frutos secos, aceite de oliva)',
      'Mantener hidratación elevada'
    ],
    training: [
      'Excelente fase para PR de fuerza si te sientes lista',
      'Cardio de alta intensidad puede rendir muy bien',
      'Sesiones largas si te sientes recuperada',
      'Considera dejar registro de tus marcas'
    ],
    recovery: [
      'No descuides el descanso aunque te sientas bien',
      'Estira y rueda tras entrenos intensos',
      'Sueño profundo para sostener el rendimiento',
      'Tiempo en exterior y luz solar puede ayudar al ánimo'
    ]
  },
  lutea_temprana: {
    name: 'Lútea temprana',
    emoji: '🌤️',
    color: '#C084FC',
    description: 'La energía empieza a estabilizarse. Algunas mujeres pueden notar cambios sutiles en hambre o ánimo.',
    feelings: [
      'Energía estable, ligeramente menor que ovulación',
      'Concentración generalmente buena',
      'Algunas pueden notar más hambre',
      'Estado de ánimo aún positivo'
    ],
    nutrition: [
      'Proteína y fibra para mayor saciedad',
      'Carbohidratos complejos repartidos en el día',
      'Magnesio (semillas, espinacas) puede apoyar el descanso',
      'Evita largos periodos sin comer si te causa irritabilidad'
    ],
    training: [
      'Mantén tu rutina pero ajusta cargas según sensación',
      'Trabajo de fuerza moderado puede rendir bien',
      'Si notas fatiga, podrías intentar reducir volumen',
      'Estiramientos y movilidad siguen siendo importantes'
    ],
    recovery: [
      'Hidratación constante',
      'Sueño regular para apoyar la fase siguiente',
      'Si notas tensión, prueba respiración o meditación',
      'Anota cómo te sientes para conocer tu patrón'
    ]
  },
  lutea_tardia: {
    name: 'Lútea tardía / premenstrual',
    emoji: '🌙',
    color: '#FF69B4',
    description: 'Los días antes del periodo. Es común notar más hambre, retención, cambios de ánimo o cansancio.',
    feelings: [
      'Algunas mujeres pueden notar más hambre o cravings',
      'Retención de líquidos o sensación de hinchazón',
      'Cambios de ánimo o mayor sensibilidad',
      'Sueño puede alterarse'
    ],
    nutrition: [
      'Prioriza proteínas y fibra para saciedad',
      'Magnesio y vitamina B6 pueden apoyar el ánimo (plátano, almendras)',
      'Reduce excesos de sodio y azúcares simples',
      'Mucha agua para la retención'
    ],
    training: [
      'Si te sientes así, podrías intentar entrenos más suaves',
      'Caminatas, yoga, pilates o movilidad',
      'No exigirte cargas máximas si notas fatiga',
      'Si te sientes bien, mantén tu rutina sin presión'
    ],
    recovery: [
      'Sueño extra puede ayudar mucho',
      'Baño tibio o estiramientos antes de dormir',
      'Sé compasiva contigo, los altibajos son normales',
      'Notas para tu próximo ciclo: registra patrones'
    ]
  }
};

export default PHASE_INFO;
